import React from 'react'

function Unary() {
    return (
        <span className='cs-exp-unary'>Unary</span>
    )
}

export { Unary }